export const DEFAULT_INFLATION_RATE = 3;
export const INTEREST_RATE_CONSERVATIVE = 5;
export const INTEREST_RATE_AGGRESIVE = 8;
export const INTEREST_RATE_SAVINGS = 1.5;
export const INTEREST_RATE_MORTGAGE = 4.8;
export const CHILDREN_INTEREST_RATE_SHORT_TERM = 5;
export const CHILDREN_INTEREST_RATE_MID_TERM = 6;
export const CHILDREN_INTEREST_RATE_LONG_TERM = 8;
export const DEFAULT_FEE_RATE = 3;
export const DEFAULT_LTV = 80;
export const DEFAULT_LOAN_DURATION = 30;
export const MIN_LOAN_DURATION = 5;
export const MAX_LOAN_DURATION = 40;
export const MAX_INFLATION_RATE = 20;
export const MAX_LOAN_INTEREST_RATE = 20;
export const DEFAULT_PENSION_DURATION = 20;
export const GROSS_INCOME_COEFICIENT = 0.7565;
export const TAXPAYER_RELIEF_CZK = 2570;
export const BASE_PENSION_AMOUNT = 4660;
export const THRESHOLD_PENSION_I = 20486;
export const THRESHOLD_PENSION_II = 186228;
export const THRESHOLD_PENSION_PERCENT_DIFF = 0.26;
export const THRESHOLD_PENSION_AGE = 1965;
export const PENSION_PERCENTAGE_AMOUNT = 0.015;
export const PENSION_YEARS_WORKED = 42;
